import { RichText } from '@obvio/template'

import { FadeIn } from '../FadeIn'
import { TextSection } from '../TextSection'

import type { ReactElement } from 'react'

type ArtistCriticismProps = {
  criticism: string
}

function parseCriticism(criticism: string): string {
  try {
    return JSON.parse(criticism)
  } catch {
    return String(criticism)
  }
}

export function ArtistCriticism({
  criticism,
}: ArtistCriticismProps): ReactElement {
  return (
    <TextSection>
      <FadeIn>
        <span>CRITICISM</span>
      </FadeIn>
      <FadeIn>
        <RichText asMap={{ h2: 'h4' }} value={parseCriticism(criticism)} />
      </FadeIn>
    </TextSection>
  )
}
